/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { combineReducers, AnyAction } from 'redux';
import userReducer from './userReducer';
import companiesReducer from './companiesReducer';
import { router5Reducer } from 'redux-router5';
import { RootState } from 'data/store.typings';
import storesReducer from './storesReducer';
import { cashBoxesReducer } from './CashBoxRegistry/cashBoxesReducer';
import { cashBoxDetailsReducer } from './CashBoxRegistry/cashboxDetailsReducer';
import { cashBoxTasksTabReducer } from './CashBoxRegistry/Tabs/cashBoxTasksTabReducer';
import operatorsReducer from './operatorsReducer';
import operatorDetailsReducer from './operatorDetailsReducer';
import companyDetailsReducer from './companyDetailsReducer';
import storeDetailsReducer from './storeDetailsReducer';
import { alertsReducer } from './alertsReducer';
import { alertsDetailsReducer } from './alertsDetailsReducer';
import { inspectorHomeReducer } from './inspectorHomeReducer';
import { reportsReducer } from './reportsReducer';
import { dashBoardFinReducer } from './dashBoardFinReducer';
import { dashBoardTechReducer } from './dashBoardTechReducer';
import { cashRegistersReducer } from './cashRegisersReducer';
import { cashRegisterDetailsReducer } from './cashRegisersDetailsReducer';
import { alertsExecutionsReducer } from './alertsExecutionsReducer';
import { alertsSettingsReducer } from './alertsSettingsReducer';
import { notificationReducer } from './notificationReducer';
import { Reducer } from 'react';
import { Router5State } from '../../router/route5ReduxHelpers';
import operatorAccHomeReducer from './OperatorAcc/OperatorAccHomeReducer';
import taxpayerAccDetailsReducer from './TaxpayerAcc/TaxpayerAccDetailsReducer';
import { shortListsReducer } from './RShortLists';
import { settingsUserInfoReducer } from './settingsUserInfoReducer';
import { settingsSecurityReducer } from './settingsSecurityReducer';
import adminUsersReducer from './adminUsersReducer';
import documentsReducer from './documentsReducer';
import devicesReducer from './devicesReducer';
import { deviceDetailsReducer } from './deviceDetailsReducer';
import { UserActionType } from '../actions/userActions';
import { cashBoxesMapReducer } from './RCashBoxesMap';
import { storeMapReducer } from './RStoreMap';
import downloadingsReducer from './downloadingsReducer';
import documentDetailsReducer from './documentDetailsReducer';
import documentDetailsPictReducer from './documentDetailsPictReducer';
import alertTemplateRulesReducer from './RAlertTemplateRules';
import { cashBoxStateTabReducer } from './CashBoxRegistry/Tabs/cashBoxStateTabReducer';
import { cashBoxStatusTabReducer } from './CashBoxRegistry/Tabs/cashBoxStatusTabReducer';
import { cashBoxTimeDeltaTabReducer } from './CashBoxRegistry/Tabs/cashBoxTimeDeltaTabReducer';
import { cashBoxAuditTabReducer } from './CashBoxRegistry/Tabs/cashBoxAuditTabReducer';
import { cashBoxAlertsTabReducer } from './CashBoxRegistry/Tabs/cashBoxAlertsTabReducer';
import { cashBoxReplacementTabReducer } from './CashBoxRegistry/Tabs/cashBoxReplacementTabReducer';
import { cashBoxCheckSumsTabReducer } from './CashBoxRegistry/Tabs/cashBoxCheckSumsTabReducer';
import { cashBoxGpsTrackingTabReducer } from './CashBoxRegistry/Tabs/cashBoxGpsTrackingTabReducer';
import { cashBoxAiClassificationTabReducer } from './CashBoxRegistry/Tabs/cashBoxAiClassificationTabReducer';
import { cashBoxDocumentsTabReducer } from './CashBoxRegistry/Tabs/cashBoxDocumentsTabReducer';
import { cashBoxLastDocumentTabReducer } from './CashBoxRegistry/Tabs/cashBoxLastDocumentTabReducer';
import statisticsReducer from './statisticsReducer';
import { cashBoxErrorHistoryTabReducer } from './CashBoxRegistry/Tabs/cashBoxErrorsTabReducer';
import serviceReducer from './serviceReducer';

const combinedReducer = combineReducers<RootState>({
    alertsReducer,
    reportsReducer,
    alertsDetailsReducer,
    userReducer,
    companiesReducer,
    companyDetailsReducer,
    operatorsReducer,
    operatorDetailsReducer,
    storesReducer,
    storeDetailsReducer,
    cashBoxesReducer,
    cashBoxDetailsReducer,
    cashBoxStateTabReducer,
    cashBoxStatusTabReducer,
    cashBoxTimeDeltaTabReducer,
    cashBoxAuditTabReducer,
    cashBoxAlertsTabReducer,
    cashBoxReplacementTabReducer,
    cashBoxCheckSumsTabReducer,
    cashBoxGpsTrackingTabReducer,
    cashBoxAiClassificationTabReducer,
    cashBoxErrorHistoryTabReducer,
    cashBoxDocumentsTabReducer,
    cashBoxLastDocumentTabReducer,
    cashBoxTasksTabReducer,
    inspectorHomeReducer,
    dashBoardFinReducer,
    dashBoardTechReducer,
    cashRegistersReducer,
    cashRegisterDetailsReducer,
    routerState: router5Reducer as unknown as Reducer<Router5State, AnyAction>,
    alertsExecutionsReducer,
    alertsSettingsReducer,
    notificationReducer,
    operatorAccHomeReducer,
    taxpayerAccDetailsReducer,
    shortListsReducer,
    settingsUserInfoReducer,
    settingsSecurityReducer,
    adminUsersReducer,
    documentsReducer,
    documentDetailsReducer,
    documentDetailsPictReducer,
    devicesReducer,
    deviceDetailsReducer,
    storeMapReducer,
    cashBoxesMapReducer,
    downloadingsReducer,
    alertTemplateRulesReducer,
    statisticsReducer,
    serviceReducer,
});
const rootReducer = (state: RootState, action: AnyAction) => {
    const routerState = state.routerState;
    if (action.type === UserActionType.LOGOUT_USER) {
        state = undefined;
    }
    return combinedReducer({ ...state, routerState }, action);
};
export default rootReducer;
